<template>
  <!-- Debugging Helper -->
  <!-- <pre class="overflow-y-scroll h-60">Bindings from Bindings List Component: {{ bindings }}</pre>
  <pre class="overflow-y-scroll h-60">props.modelValue from Bindings List Component: {{ props.modelValue }}</pre> -->


  <!-- Bindings List -->
  <div class="pe-table-wrap">
    <table class="pe-table" v-if="bindings.length">
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">
            {{ header }}
          </th>
          <th class="pe-table__actions-col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(binding, rowIndex) in bindings" :key="rowIndex">
          <td>
            {{ binding.humanReadableInfo?.implementationName }}
          </td>
          <td>
            {{ binding.humanReadableInfo?.instanceName }}
          </td>
          <td>
            <ul class="binding-summary">
              <li v-for="(line, index) in binding.humanReadableInfo?.bindingOptionsSummaryLines" :key="index">
                {{ line }}
              </li>
            </ul>
          </td>
          <td>
            {{ binding.description }}
          </td>
          <td class="pe-table__actions">
            <div class="binding-row-actions">
              <BindingDialog mode="edit" v-model="bindings[rowIndex]" :key="rowIndex" />
              <button
                type="button"
                class="pe-row-action-btn"
                aria-label="Remove binding"
                @click="removeBinding(rowIndex)"
              >
                <PhTrash :size="16" weight="bold" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="bindings-empty" v-else>No Subscription Binding Added to this Subscription yet.</div>
  </div>
</template>

<script setup lang="ts">
import { ref, type PropType, watch } from 'vue';
import { PhTrash } from '@phosphor-icons/vue';
import BindingDialog from './BindingDialog.vue';

const props = defineProps({
  'modelValue': {
    type: Array as PropType<any[]>,
    default: () => [] as any[]
  }
});

const bindings = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

const headers = [
  "Integration Service",
  "Integration Instance",
  "Binding Options",
  "Binding Description"
]

const removeBinding = (index: number) => {
  bindings.value.splice(index, 1);
  emit('update:modelValue', bindings.value);
};

watch([() => props.modelValue], () => {
  bindings.value = props.modelValue;
}, { deep: true });

watch([bindings], () => {
  emit('update:modelValue', bindings.value);
}, { deep: true });
</script>

<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

.pe-table-wrap {
  margin-top: 0.5rem;
}

.pe-table td {
  vertical-align: top;
}

.binding-summary {
  margin: 0;
  padding: 0;
  list-style: none;
}

.binding-row-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.bindings-empty {
  padding-top: 0.5rem;
  color: var(--bui-tbl-detail-text, #5c5c66);
  font-size: 0.875rem;
}
</style>
